/**
 * 예산관리 금액단위
 * - 콤보는 「금액이 어떤 단위인지」 안내/표시용
 * - 단위 변경 시 숫자 환산(÷1000 등)하지 않음
 */

export const AMOUNT_UNIT = {
  WON: 'WON',
  THOUSAND: 'THOUSAND',
  MILLION: 'MILLION',
};

export const DEFAULT_AMOUNT_UNIT = AMOUNT_UNIT.THOUSAND;

export const AMOUNT_UNIT_OPTIONS = [
  { value: AMOUNT_UNIT.WON, name: '원' },
  { value: AMOUNT_UNIT.THOUSAND, name: '천원' },
  { value: AMOUNT_UNIT.MILLION, name: '백만원' },
];

export const getAmountUnitLabel = (unit = DEFAULT_AMOUNT_UNIT) => {
  const found = AMOUNT_UNIT_OPTIONS.find((item) => item.value === unit);
  return found?.name ?? '천원';
};

/** 표시/계산용 숫자 파싱 (단위 환산 없음) */
export const toBudgetDisplayAmount = (value) => {
  const num =
    typeof value === 'number'
      ? value
      : Number(String(value ?? '').replace(/,/g, ''));
  if (isNaN(num)) return 0;
  return num;
};

/** 그리드/출력용 금액 포맷 (단위와 무관하게 숫자만 천단위 구분) */
export const formatBudgetAmount = (value) => {
  if (value == null || value === '') return '0';

  const display = toBudgetDisplayAmount(value);
  if (Number.isInteger(display)) {
    return display.toLocaleString('ko-KR');
  }

  return display.toLocaleString('ko-KR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

/** 입력값 파싱 (단위 배수 적용 없음, 입력한 숫자 그대로 저장) */
export const parseBudgetAmountInput = (newValue) => {
  const cleaned = String(newValue ?? '').replace(/,/g, '').trim();
  if (!cleaned) return 0;

  const parsed = parseFloat(cleaned);
  if (isNaN(parsed)) return 0;

  return Number.isInteger(parsed) ? parsed : Math.round(parsed * 100) / 100;
};

export const createBudgetAmountFormatter = () => {
  return (params) => formatBudgetAmount(params.value);
};

export const createBudgetAmountParser = () => {
  return (params) => parseBudgetAmountInput(params.newValue);
};
